// This keeps the mega menu from falling off the page
jQuery(function () {
    jQuery("li.menu-item-has-children").on('click', function (e) {
        if (jQuery('.sub-menu', this).length) {
            var elm = jQuery('.sub-menu', this);
            var off = elm.offset();
            var l = off.left;
            var w = elm.width();
            var docW = jQuery(".site-wrapper").width();

            var isEntirelyVisible = (l + w <= docW);
            if (!isEntirelyVisible) {
                jQuery(elm).addClass('edge');
            } 
        }
    });
});